import React from 'react';
import { services } from '../../mock';
import { Activity, Droplet, Heart, Shield, Stethoscope, Scale } from 'lucide-react';

const iconMap = { Activity, Droplet, Heart, Shield, Stethoscope, Scale };

export const ServicesSection = () => {
  return (
    <section id="services" className="section" data-testid="services-section">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4" style={{ color: 'var(--sage-dark)' }}>Our Services & Specialties</h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Comprehensive internal medicine services for adults, focusing on prevention and
            chronic disease management.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div key={service.id} className="service-card" data-testid={`service-card-${service.id}`}>
                <div className="service-icon">
                  {IconComponent && <IconComponent className="w-6 h-6" />}
                </div>
                <h3 className="text-xl font-bold mb-3" style={{ color: 'var(--sage-dark)' }}>{service.name}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <div className="p-6 max-w-3xl mx-auto rounded-r-lg" style={{ backgroundColor: 'rgba(139, 111, 71, 0.1)', borderLeft: '4px solid var(--earth-accent)' }}>
            <p className="text-lg text-gray-700">
              <strong style={{ color: 'var(--sage-dark)' }}>Our commitment:</strong> Prevention, continuity of care,
              and a dedication to improving your quality of life through comprehensive internal medicine.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
